export default __webpack_public_path__ + "static/media/dsi-logo.9c13221a.svg";